/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var InfoCircleIcon16Regular = forwardRef('InfoCircleIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" }),
        React.createElement("path", { d: "M7.268 6.945a.75.75 0 0 0 0 1.5h.25v2.043H7a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-.482V7.695a.75.75 0 0 0-.75-.75h-1Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8Zm7-5.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Z" })));
});
